import React, { FC } from 'react'

import { HighlightedTextProps } from '@/types'
import { getStyledElementProps } from '@/utils'
import { Typography } from '@/atoms/typography'

import styles from './highlighted-text.module.scss'

export const HighlightedText: FC<HighlightedTextProps> = ({
  label,
  children,
  labelColor = 'gray-6',
  containerProps = {},
  wrapperProps = {},
  labelProps = {},
}) => {
  const styledContainerProps = getStyledElementProps(
    containerProps,
    styles['container']
  )
  const styledWrapperProps = getStyledElementProps(
    wrapperProps,
    styles['wrapper']
  )
  const styledLabelProps = getStyledElementProps(labelProps, styles['label'])
  return (
    <div {...styledContainerProps}>
      {label && (
        <Typography
          variant={'body-2'}
          typographyColor={labelColor}
          {...styledLabelProps}
        >
          {label}
        </Typography>
      )}
      <span {...styledWrapperProps}>
        <Typography variant={'code-1'} typographyColor={'white'}>
          {children}
        </Typography>
      </span>
    </div>
  )
}
